import React from "react"
import './Step1.scss'
import { useTranslation } from 'react-i18next'

const Step1 = ({fileOrBd}) => {
    const { t } = useTranslation()

    return (
        <div className='step1-content'>
                { t('messages.aml.cdi.step1.heading') }
                <br/>
                <br/>
                { t('messages.aml.cdi.step1.fileOptionPrefix') } <a href="#" onClick= { () => fileOrBd("file") }>{ t('messages.aml.cdi.step1.pressHere') }</a>
                <br/>
                <br/>
                <br/>
                { t('messages.aml.cdi.step1.bdOptionPrefix') } <a href="#" onClick={ () => fileOrBd("bd") }>{ t('messages.aml.cdi.step1.pressHere') }</a>
        </div>
    )
}
export default Step1
